<template lang="pug">
  DefaultLayout(:topMenuItems="hideHeader ? null : topMenuItems" :key="$route.params.projectId")
    template
      router-view(:project="project" v-if="!hideHeader")
    template(v-slot:header)
      ProjectDetail(v-if="project && showHeader && !hideHeader" :project="project")
      BasePopup(v-if="isErrorPopup" @close="isErrorPopup = false")
        .err-popup Партнёр, по ссылке которого вы зарегистрировались на платформе, поделился своим авторским проектом. Это шаблон дизайн-проекта, который можно скопировать себе и использовать, как шаблон. Он станет доступен после оплаты любого платного тарифа на месяц или больше.
          .err-popup-buttons
            Btn(:to="{ name: 'tariffs' }") Тарифы
            Btn(@click="isErrorPopup = false") Закрыть
</template>

<script>
import Access from '@/utils/access';

import DefaultLayout from '@/layouts/Default.vue';
import ProjectDetail from '@/components/ProjectDetail.vue';
import BasePopup from '@/components/BasePopup.vue';

export default {
  name: 'ProjectDetailPage',
  components: { DefaultLayout, ProjectDetail, BasePopup },
  data() {
    return {
      isErrorPopup: false,
      hideHeader: false,
    };
  },
  created() {
    const { projectId } = this.$route.params;
    this.$store.dispatch('project/fetchProject', { projectId, force: true });
  },
  watch: {
    project(val) {
      document.title = val.name;
      this.checkReferral();
    },
    '$route.params.projectId': function () {
      const { projectId } = this.$route.params;
      this.$store.dispatch('project/fetchProject', { projectId, force: true });
    },
  },
  computed: {
    project() { return this.$store.state.project.project; },
    showHeader() { return this.$route.meta.showProjectHeader; },
    access() { return this.project ? new Access(this.project, this.$store.state.auth.user) : {}; },
    err403() { return this.$store.getters['error/err403']; },
    topMenuItems() {
      if (this.err403) return null;

      const items = [
        { label: 'Задачи',    to: { name: 'project-stages'      } }, // eslint-disable-line
        { label: 'Описание',  to: { name: 'project-description' } }, // eslint-disable-line
        { label: 'События',   to: { name: 'project-events'      } }, // eslint-disable-line
        { label: 'Файлы',     to: { name: 'project-files'       } }, // eslint-disable-line
      ];

      if (!this.project?.isReferralSample && (this.access.isProjectAuthor?.() || this.access.isProjectAdmin?.())) {
        items.push({ label: 'Участники', to: { name: 'project-members'  } }); // eslint-disable-line
      }

      items.push({ label: 'Диаграмма Ганта', blank: true, to: { name: 'gantt', query: { project: this.project?.id } } }); // eslint-disable-line
      items.push({ label: 'Гайды', to: { name: 'guides' } }); // eslint-disable-line

      return items;
    },
  },
  methods: {
    checkReferral() {
      if (this.access.isProjectAuthor() || this.access.isProjectMember() || this.access.isReferralSampleViewAccessible()) return;

      this.hideHeader = true;
      this.isErrorPopup = true;
      this.$store.commit('error/add', { status: 403 });
    },
  },
};
</script>

<style scoped lang="scss">
  .err-popup {
    display: flex;
    flex-direction: column;
    max-width: 400px;
    gap: 50px;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: #000;

    &-buttons {
      display: flex;
      justify-content: center;
      gap: 30px;
    }
  }
</style>
